import React, { useState } from 'react';
import {
  Button,
  Header,
  Image,
  Modal,
  Popup,
  Label,
  Input,
  Portal,
  Segment,
} from 'semantic-ui-react';
import styled from 'styled-components';

const ProxyBidModal = ({
  buttonText = 'Open Modal',
  initialModalOpenState = false,
  state = {},
  onClose,
  onDelete,
  onUpdate,
}) => {
  const [open, setOpen] = useState(initialModalOpenState);
  const [newProxyValue, setNewProxyValue] = useState(state.proxyBid);
  const [status, setStatus] = useState();

  const handleClose = (fn) => {
    onClose();
    setOpen(false);
    if (fn && typeof fn === 'function') fn();
  };

  return (
    <Portal
      onClose={() => {
        onClose();
        setOpen(false);
      }}
      onOpen={() => setOpen(true)}
      open={open}
      size="tiny"
      closeOnDocumentClick={false}
      closeOnEscape={false}
    >
      <Segment
        style={{
          left: '40%',
          position: 'fixed',
          width: '400px',
          top: '40%',
          zIndex: 1000,
          padding: '30px 20px',
        }}
      >
        <h3>You may update the proxy bid amount or delete it.</h3>
        <FlexContainer>
          <label>Member Name:</label>
          <div>{state.memberName}</div>
        </FlexContainer>
        <FlexContainer>
          <label>Lot Number:</label>
          <div>{state.lotNumber}</div>
        </FlexContainer>
        <FlexContainer>
          <label>Proxy Bid:</label>
          <div>
            <Input
              labelPosition="left"
              type="number"
              placeholder="Enter proxy"
              value={newProxyValue}
              onChange={(e) => setNewProxyValue(e.currentTarget.value)}
            >
              <Label basic>$</Label>
              <input
                type="number"
                style={{ width: '110px', textAlign: 'right' }}
              />
            </Input>
          </div>
        </FlexContainer>
        {status && (
          <FlexContainer>
            <div
              style={{
                color: status.result.success ? 'green' : 'red',
                width: '100%',
                paddingTop: '10px',
              }}
            >
              {status.clickType === 'update' &&
                status.result.success &&
                `😃 You have successfully updated the new proxy bid to $${new Intl.NumberFormat().format(
                  status.newProxyBid,
                )}. The page will now be updated...`}
              {status.clickType === 'update' &&
                !status.result.success &&
                `🤔 Oops, an error occurred while trying to update the proxy bid (API: ${status.result.message})`}
              {status.clickType === 'delete' &&
                status.result.success &&
                `😃 You have successfully deleted the proxy bid. The page will now be updated...`}
              {status.clickType === 'delete' &&
                !status.result.success &&
                `🤔 Oops, an error occurred while trying to delete the proxy bid (API: ${status.result.message})`}
            </div>
          </FlexContainer>
        )}
        <ButtonContainer>
          <Button
            content="Cancel"
            floated="right"
            loading={false}
            disabled={false}
            onClick={handleClose}
          />
          <Button
            negative
            content="Delete"
            floated="right"
            icon="times"
            loading={false}
            disabled={false}
            onClick={async () => {
              const res = await onDelete({
                proxyBidID: state.proxyBidID,
                auctionID: state.auctionID,
              });
              setStatus({ ...res, clickType: 'delete' });
              if (res.result.success) {
                setTimeout(() => {
                  handleClose();
                }, 2000);
              }
            }}
          />
          <Button
            primary
            content="Update"
            floated="right"
            icon="checkmark"
            loading={false}
            disabled={Number(state.proxyBid) === Number(newProxyValue)}
            onClick={async () => {
              const res = await onUpdate({
                proxyBidID: state.proxyBidID,
                proxyBid: newProxyValue,
                auctionID: state.auctionID,
              });
              setStatus({ ...res, clickType: 'update' });
              if (res.result.success) {
                setTimeout(() => {
                  handleClose();
                }, 2000);
              }
            }}
          />
        </ButtonContainer>
      </Segment>
    </Portal>
  );
};

export default ProxyBidModal;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 2.5rem;
  & > label {
    font-weight: bold;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;
